import React from 'react';
import { CalendarCheck2, CalendarClock, CalendarX2, Flame, Layers } from 'lucide-react';

const StatCard = ({ label, labelTone, icon: Icon, iconTone, value, note }) => (
  <li className="bg-white rounded-2xl border border-slate-200/90 shadow-sm p-4">
    <div className="flex items-start justify-between gap-2">
      <span className={`text-[11px] font-bold uppercase tracking-wider ${labelTone}`}>{label}</span>
      <span className={`w-7 h-7 rounded-lg border flex items-center justify-center flex-shrink-0 ${iconTone}`}>
        <Icon className="w-3.5 h-3.5" />
      </span>
    </div>
    <p className="mt-2 text-2xl font-extrabold tracking-tight text-slate-900">{value}</p>
    <p className="mt-1 text-xs text-slate-500">{note}</p>
  </li>
);

export const CalendarStatCards = ({ stats }) => (
  <ul className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-3 sm:gap-4">
    <StatCard
      label="Total Events"
      labelTone="text-slate-500"
      icon={Layers}
      iconTone="bg-teal-50 text-[#008080] border-teal-100"
      value={stats.total}
      note="Mainboard & SME actions"
    />
    <StatCard
      label="Bidding Opens"
      labelTone="text-emerald-600"
      icon={CalendarClock}
      iconTone="bg-emerald-50 text-emerald-600 border-emerald-100"
      value={`${stats.opens} ${stats.opens === 1 ? 'Issue' : 'Issues'}`}
      note={stats.openSizeCr ? `₹${Math.round(stats.openSizeCr).toLocaleString('en-IN')} Cr combined size` : 'No openings this month'}
    />
    <StatCard
      label="Bidding Closes"
      labelTone="text-orange-600"
      icon={CalendarX2}
      iconTone="bg-orange-50 text-orange-600 border-orange-100"
      value={`${stats.closes} ${stats.closes === 1 ? 'Issue' : 'Issues'}`}
      note="UPI cut-off 5:00 PM IST"
    />
    <StatCard
      label="Allotment Status"
      labelTone="text-sky-600"
      icon={CalendarCheck2}
      iconTone="bg-sky-50 text-sky-600 border-sky-100"
      value={`${stats.allotmentsDone} Finalized`}
      note={
        stats.allotmentsPending
          ? `${stats.allotmentsPending} pending${stats.registrars ? ` · ${stats.registrars} registrars` : ''}`
          : stats.registrars
            ? `Across ${stats.registrars} registrars`
            : 'No allotments pending'
      }
    />
    <li className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-slate-900 via-[#0a3434] to-[#006666] text-white shadow-sm p-4 col-span-2 md:col-span-1">
      <div className="flex items-start justify-between gap-2">
        <span className="text-[11px] font-bold uppercase tracking-wider text-teal-100">Super Rush Alert</span>
        <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-rose-500 text-[10px] font-extrabold uppercase">
          <Flame className="w-3 h-3" />
          Hot
        </span>
      </div>
      <p className="mt-2 text-xl font-extrabold tracking-tight">{stats.rushLabel || 'No rush days'}</p>
      <p className="mt-1 text-xs text-teal-100/90">
        {stats.rushCount
          ? `${stats.rushCount} bidding actions${stats.rushDays > 1 ? ' each' : ''}`
          : 'Bidding activity is spread out'}
      </p>
    </li>
  </ul>
);

export default CalendarStatCards;
